import { Divider, Skeleton, Space, Typography } from 'antd';
import { useUserProfilePermissions } from 'hooks';
import { usersMessages } from 'messages/users.messages';

const UserProfilePermissionsTab = () => {
  const { userPermissions, isLoading } = useUserProfilePermissions();
  if (isLoading)
    return (
      <div>
        <Skeleton />
        <Divider className='my-4' />
        <Skeleton />
      </div>
    );
  return (
    <div>
      <Typography.Title className='mb-0' level={5}>
        {usersMessages.personalPermission}
      </Typography.Title>
      <div className='my-2'>
        <Space direction='vertical' size={8}>
          {userPermissions?.permissions.map((itm) => (
            <Typography.Text key={itm.permissionId}>{itm.name}</Typography.Text>
          ))}
        </Space>
      </div>
      {userPermissions?.roles?.length ? (
        <div>
          <Space direction='vertical' size={8}>
            {userPermissions.roles.map((itm) => (
              <Typography.Text key={itm.roleId}>{itm.name}</Typography.Text>
            ))}
          </Space>
        </div>
      ) : null}
      <Divider className='my-6' />
      {userPermissions?.userGroups?.map((userGroup) => (
        <div key={userGroup.userGroupId}>
          <Typography.Title className='mb-0' level={5}>
            {usersMessages.groupPermission} {userGroup.name}
          </Typography.Title>
          <div className='my-2'>
            <Space direction='vertical' size={8}>
              {userGroup.permissions.map((itm) => (
                <Typography.Text key={itm.permissionId}>{itm.name}</Typography.Text>
              ))}
            </Space>
          </div>
          {userGroup.roles?.length ? (
            <div>
              <Space direction='vertical' size={8}>
                {userGroup.roles.map((itm) => (
                  <Typography.Text key={itm.roleId}>{itm.name}</Typography.Text>
                ))}
              </Space>
            </div>
          ) : null}
        </div>
      ))}
    </div>
  );
};
export default UserProfilePermissionsTab;
